import { useQuery, UseQueryResult } from 'react-query';
import { OtherWorkEventRetrieve } from 'types';
import { client } from 'utils/api-client';

function useOtherWorkEvent(
  otherWorkEventId: string | undefined,
): UseQueryResult<{ data: OtherWorkEventRetrieve }> {
  return useQuery(
    ['otherWorkEvents', otherWorkEventId],
    () => client.get(`other-work-events/${otherWorkEventId}/`),
    {
      enabled: !!otherWorkEventId,
    },
  );
}

export default useOtherWorkEvent;
